module.exports = __webpack_public_path__ + "img/rune.caacc8f0.svg";